import * as types from '../mutation-types'
import Vue from 'vue'

const state = {
  captcha_img: ''
}

const mutations = {
  [types.GET_CAPTCHA_LINK] (state, data) {
    state.captcha_img = data.captcha_img
  }
}

const actions = {
  getCaptchaLink ({ commit }, queryData) {
    return new Promise(function(resolve, reject) {
      Vue.http.get('api/captcha/getCaptchaLink?phone_num='+queryData).then((response) => {
        if (response.data.code === 0) {
          commit(types.GET_CAPTCHA_LINK, response.data.data)
          resolve(response.data.code)
        } else {
          reject()
        }
      })
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/captcha.js